module.exports = __webpack_public_path__ + "img/resources.28225002.svg";